// Generated by scripts/generate-public-surface.ts. Do not edit.
export { default as codiceFiscale } from "./codicefiscale";
export { default as iva } from "./iva";
